<template>
  <div class="mcw">
    <div class="mcw__content">
      <router-view />
    </div>
  </div>
</template>

<script>
import storage from '@lagersoft/key-storage';
import getUrlParams from '../utils/getUrlParams';

export default {
  name: 'MCW',
  created() {
    if (getUrlParams('t')) {
      const token = getUrlParams('t');
      storage.set('tokenMCW', token);
    }
  }
};
</script>

<style lang="scss" scoped>
.mcw {
  min-height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  .mcw__content {
    width: 100%;
    max-width: 1140px;
    padding-inline: 15px;
  }
}
</style>
